import { contentManagerTour } from './ContentManager'
import type { TourStep } from './Types'

export const tours: Record<string, TourStep[]> = {
	'content-manager': contentManagerTour,
}

export function getTourSteps(tourId: string): TourStep[] {
	return tours[tourId] ?? []
}
